module.exports = __webpack_public_path__ + "static/media/upload.b968178f.svg";